document.addEventListener("DOMContentLoaded", function () {
  function checkingthecart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        for (let other_item of cart.items) {
          let removebolean = false;
          let monogram_key = other_item.properties.monogram;
          let other_item_keyy; // declare other_item_keyy outside the if block

          if (monogram_key) {
            other_item_keyy = other_item.key;

            for (let monoforit of cart.items) {
              let monofor = monoforit.properties._monofor;

              if (monofor == monogram_key) {
                removebolean = true;
              }
            }
          }

          if (!removebolean) {
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              dataType: "json",
              data: {
                id: other_item_keyy,
                quantity: 0,
              },
            }).then((data) => {
              console.log(data);
              window.location.reload();
              window.scrollTo(0, 0);
            });
          }
        }
      });
  }
  $(document).on("click", "button[data-remove-item]", function () {
    setTimeout(() => {
      checkingthecart();
    }, 800);
  });
  checkingthecart();
});
